module.exports = __webpack_public_path__ + "static/media/story-video.4b74ac96.gif";


//////////////////
// WEBPACK FOOTER
// ./src/components/DevicePreview/story-video.gif
// module id = 1512
// module chunks = 0